import { Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import { WorkflowBanner } from './components/Canvas/components/WorkflowBanner/WorkflowBanner';
import { Background } from './components/Canvas/components/Background';
import { Canvas } from './components/Canvas/Canvas';
import { FloatingEdge } from './components/Canvas/components/FloatingEdge';
import { WorkflowGroup } from './components/WorkflowBox/WorkflowGroup';
import { useWorkFlowCanvas } from './contexts/CampaignFlowProvider';
import styled from 'styled-components';
import { useOnNodeChangeWorkFlowCanvas } from './components/Canvas/state/actions/useOnNodeChangeWorkFlowCanvas';
import { useOnEdgeChangeWorkFlowCanvas } from './components/Canvas/state/actions/useOnEdgeChangeWorkFlowCanvas';
import { NodeTypes } from './NodeTypes';
import { useDrawer } from './state/Drawer/hooks/useDrawer';
import { useMemo } from 'react';

const edgeTypes = { floating: FloatingEdge };

const StyledControls = styled(Controls)`
  .react-flow__controls {
    margin: 0 24px 24px 0;
    box-shadow: ${({ theme }) => theme.designToken.boxShadow0};
  }

  & .react-flow__controls-button:first-child {
    border-radius: 4px 4px 0 0;
  }

  & .react-flow__controls-button:last-child {
    border-radius: 0 0 4px 4px;
  }

  & .react-flow__controls-button {
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
    color: ${({ theme }) => theme.vars.newColor.darkGS2};
    :hover {
      background-color: ${({ theme }) => theme.designToken.primary50};
      border: 1px solid ${({ theme }) => theme.designToken.primary500};
    }
  }
`;

export function TriggerCanvas() {
  const { state } = useWorkFlowCanvas();

  const onNodeChangeWorkFlowCanvas = useOnNodeChangeWorkFlowCanvas();
  const onEdgeChangeWorkFlowCanvas = useOnEdgeChangeWorkFlowCanvas();

  const onNodesChange = (changes: any) => {
    onNodeChangeWorkFlowCanvas(changes);
  };

  const onEdgesChange = (changes: any) => {
    onEdgeChangeWorkFlowCanvas(changes);
  };

  const drawer = useDrawer();
  const activeWorkflowId = useMemo(() => drawer.drawer.id, [drawer.drawer.id]);

  return (
    <WorkflowGroup activeId={activeWorkflowId}>
      <WorkflowBanner />
      <Canvas
        nodes={state.nodes}
        edges={state.edges}
        nodeTypes={NodeTypes}
        elementsSelectable={false}
        edgeTypes={edgeTypes}
        onEdgesChange={onEdgesChange}
        onNodesChange={onNodesChange}
      >
        <Background />
        <StyledControls showInteractive={false} position="bottom-right" style={{ marginRight: 24, marginBottom: 24 }} />
      </Canvas>
    </WorkflowGroup>
  );
}
